"use client";

import { useState } from "react";

type Testimonial = {
  name: string;
  text: string;
};

function TestimonialCard({ testimonials }: { testimonials: Testimonial[] }) {
  const [active, setActive] = useState(0);
  const t = testimonials[active];

  return (
    <div className="relative flex flex-col justify-between rounded-3xl border border-white/10 bg-white/[0.03] p-8 min-h-[280px]">
      {/* Quote mark */}
      <span
        className="absolute top-6 right-8 text-5xl text-white/20 select-none leading-none"
        style={{ fontFamily: "Georgia, serif" }}
      >
        "
      </span>

      {/* Content */}
      <div>
        <p className="text-sm font-normal text-white font-body mb-5">{t.name}</p>
        <p className="text-sm leading-relaxed text-white/55 font-body">{t.text}</p>
      </div>

      {/* Dots */}
      <div className="flex gap-2 justify-center mt-8">
        {testimonials.map((_, i) => (
          <button
            key={i}
            onClick={() => setActive(i)}
            className={`w-1.5 h-1.5 rounded-full transition-colors duration-200 cursor-pointer ${
              i === active ? "bg-white" : "bg-white/20"
            }`}
          />
        ))}
      </div>
    </div>
  );
}

export default function Testimonials({
  title,
  subtitle,
  leftTestimonials,
  rightTestimonials,
}: {
  title: string;
  subtitle: string;
  leftTestimonials: Testimonial[];
  rightTestimonials: Testimonial[];
}) {
  return (
    <section className="bg-[#0b0b0d] py-20">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <h2 className="font-heading text-5xl md:text-6xl text-white font-light italic">
            {title}
          </h2>
          <p className="mt-4 text-sm text-white/45 font-body max-w-sm mx-auto leading-relaxed">
            {subtitle}
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <TestimonialCard testimonials={leftTestimonials} />
          <TestimonialCard testimonials={rightTestimonials} />
        </div>
      </div>
    </section>
  );
}
